import clsx from 'clsx';
import { AnchorLink } from './partials';
import type { AnchorLinkCollectionProps } from './types';

/**
 * AnchorLinkCollection Component
 *
 * Renders a collection of anchor links in a horizontal scrollable grid layout.
 *
 * Each anchor link contains:
 * - An image
 * - An optional title displayed below the image
 * - A link (using LinkWithMasking) that supports both internal and external URLs
 *
 * @param props - AnchorLinkCollection properties
 * @param props.anchorLinks - Array of anchor link nodes from the data layer
 * @param props.device - Device type (mobile or desktop) for responsive rendering
 * @returns A JSX element rendering a horizontally scrollable list of anchor links
 */
export function AnchorLinkCollection({ anchorLinks, device }: AnchorLinkCollectionProps) {
  return (
    <ul className={clsx('anchor-link-collection')}>
      {anchorLinks?.map((anchorLink, index) =>
        anchorLink ? (
          <AnchorLink
            key={`${index}-${anchorLink.title}`}
            device={device}
            deviceType={anchorLink.deviceType}
            title={anchorLink.title}
            subtitle={anchorLink.subtitle}
            image={anchorLink.image}
            link={anchorLink.link}
            theme={anchorLink.theme}
          />
        ) : null,
      )}
    </ul>
  );
}
